import React from 'react';

import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';
import { makeSequence } from 'dpl/shared/utils';
import { isLessThanBreakpoint } from 'dpl/util/grid';

const IS_LT_MD = isLessThanBreakpoint('md');

export default function BreederProfileMeetBreederSectionSkeleton() {
  return (
    <div className="BreederProfileMeetBreederSectionSkeleton container-xxl mv8 mv20-md">
      <div className="flex flex-column flex-md-row gap-x-96">
        <div className="w-50-md">
          <SkeletonBlock
            className="font-28 md:font-40 mb5 mb6-md"
            height="1em"
            width="8em"
          />
          <SkeletonBlock
            className="font-16 md:font-18 mb8"
            height={IS_LT_MD ? '8em' : '5em'}
          />
          <div className="aspect-ratio aspect-ratio--6x4 relative mb10 mb13-md dn-ns">
            <SkeletonBlock className="aspect-ratio--object br3" />
          </div>
          <SkeletonBlock
            className="font-24 lh-title mb4 mb6-md"
            height="1em"
            width="8em"
          />
          <div className="flex flex-column gap-32">
            {makeSequence(3).map(index => (
              <div key={index}>
                <SkeletonBlock
                  className="font-16 md:font-18 lh-title mb3"
                  height="1em"
                  width="50%"
                />
                <SkeletonBlock className="font-16 md:font-18" height="4em" />
              </div>
            ))}
          </div>
        </div>
        <div className="dn db-ns w-50-md">
          <div className="aspect-ratio aspect-ratio--6x4 relative mb10 mb13-md">
            <SkeletonBlock className="aspect-ratio--object br3" />
          </div>
        </div>
      </div>
    </div>
  );
}
